let squareFormMixin = {
	data: function () {
		return {
			paymentForm: null,
			card: null
		}
	},
	computed: {
		totalPrice: function () {
			return this.$store.getters.totalCheckoutPrice
		}
	},
	methods: {
		async tokenize(paymentMethod) {
			const tokenResult = await paymentMethod.tokenize()
			if (tokenResult.status === "OK") {
				return tokenResult
			} else {
				let errorMessage = `Tokenization failed-status: ${tokenResult.status}`
				if (tokenResult.errors) {
					this.$store.dispatch("setInPurchaseState", false)
					errorMessage += ` and errors: ${JSON.stringify(
						tokenResult.errors
					)}`
				}
				throw new Error(errorMessage)
			}
		},
		async clickPurchase(event) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Click Purchase Start",
				data: {
					type: "Credit Card"
				}
			})
			if (!this.$store.state.inPurchaseState) {
				this.$store.dispatch("setInPurchaseState", true)
				if (event) {
					event.preventDefault()
				}
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Click Purchase",
					data: {
						type: "Credit Card"
					}
				})

				const tokenResult = await this.tokenize(this.card)
				this.chargeCard(
					tokenResult.token,
					tokenResult.details.billing.postalCode
				)
				if (this.toggleLoader) {
					this.toggleLoader(true)
				} else {
					this.$emit("toggleLoader", true)
				}
			} else {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Click Purchase Disabled",
					data: {
						type: "Credit Card"
					}
				})
			}
		},
		chargeCard(nonce, postalCode) {
			const payload = {
				nonce: nonce,
				wallet_type: "NONE",
				user_zip: postalCode
			}

			// if (this.card.id) {
			// 	payload.card_id = this.card.id
			// }

			// if (this.saveCard) {
			// 	payload.save_card = 1
			// }

			this.$store.dispatch("chargeCard", payload)
		}
	},

	created: function () {
		this.paymentForm = window.Square.payments(
			`${process.env.VUE_APP_SQUARE_APPLICATION_ID}`,
			`${process.env.VUE_APP_SQUARE_LOCATION_ID}`
		)
	},
	mounted: async function () {
		try {
			// initialize card payment
			this.card = await this.paymentForm.card()
			this.card.attach("#card-container")
		} catch (e) {
			console.error("Initializing Card failed", e)
			return
		}
	}
}

export default squareFormMixin
